define(function (require) {

    window.lpTag = window.lpTag || {};

    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var VisitorBehaviors = require('web-agent-assets-js/lpVisitorBehaviors');
    var lpBaseInfoController = require('web-agent-assets-js/lpBaseInfoController');
    var agentLEManager = require('web-agent-utils/agentLEManager');


    lpTag.lpVisitorBehaviorController = function (model) {
        this.applicationType = "lpVisitorBehaviorController";
        var logger = WebAgentLogger.getLogger(this.applicationType);

        var visitorBehaviorApi;

        this.getVisitorBehavior = function (data) {
            getVisitorBehavior(data);
        };

        this.getSingleVisitorBehaviorObject = function (behaviorObject, name) {
            return getSingleVisitorBehaviorObject(behaviorObject, name);
        };
        initializeApi();

        function initializeApi() {
            visitorBehaviorApi = new VisitorBehaviors();
        }

        /////////////////////////////// VISITOR BEHAVIOR DATA ///////////////////////////////////

        function getVisitorBehavior(data) {
            logger.debug("", "getVisitorBehavior", data);
            var id;
            if (data) {
                id = data.id;
            }
            if (id) {
                var requestObj = {
                    success: lpUtils.callbackContextWrapper(handleVisitorBehaviorSuccess, data),
                    error: lpUtils.callbackContextWrapper(handleVisitorBehaviorError, data),
                    context: data
                };
                visitorBehaviorApi.getBehavior(requestObj, id);
            }
        }

        function handleVisitorBehaviorSuccess(data) {
            logger.info("VisitorBehavior return as Success", "handleVisitorBehaviorSuccess");
            var context = data && data.context;
            var dataObject = (data && data.dataObject) || (context && context.dataObject);
    //      if it's the default visitorBehavior save in the model the default languino strings - so it will be the right strings and also it will be translated to the right language
            if(data && data.body && data.body.isSystemDefault){
                data.body.name = agentLEManager.translateLE("LEWebAgent.visitorBehavior.default.name");
                data.body.description = agentLEManager.translateLE("LEWebAgent.visitorBehavior.default.description");
            }
            lpTag.lpVisitorBehaviorController.prototype.handleACRequestSuccess(model, data, lpTag.lpVisitorBehaviorController.prototype.serviceNames.visitorBehavior, getSingleVisitorBehaviorObject, context, dataObject);
        }

        function handleVisitorBehaviorError(data) {
            logger.error("", "handleVisitorBehaviorError", data);
            logger.graph({name: 'handleVisitorBehaviorError'});
            var context = data && data.context;
            var dataObject = (data && data.dataObject) || (context && context.dataObject);
            lpTag.lpVisitorBehaviorController.prototype.handleRequestError(model, data, lpTag.lpVisitorBehaviorController.prototype.serviceNames.visitorBehavior, data && data.visitorId, dataObject);
        }

        function getSingleVisitorBehaviorObject(behaviorObject, name) {
            var toReturn = lpTag.lpVisitorBehaviorController.prototype.getDataFromModelIfNotModified(model, this, name) || {
                    id: behaviorObject.id,
                    description: behaviorObject.description,
                    name: behaviorObject.name
                };
            var visitorId = behaviorObject && (behaviorObject.visitorId || (behaviorObject.dataObject && behaviorObject.dataObject.data && behaviorObject.dataObject.data.visitorId));
            lpTag.lpVisitorBehaviorController.prototype.addToVisitorInfoById(model, 'visitorBehavior', toReturn, visitorId, behaviorObject && behaviorObject.dataObject, lpTag.lpVisitorBehaviorController.prototype.serviceNames.visitorBehavior);
            return toReturn;
        }
    };
    lpTag.lpVisitorBehaviorController.prototype = new lpBaseInfoController();

    return lpTag.lpVisitorBehaviorController;

});
